import * as actionTypes from "./actionTypes";
import * as types from "./types";

// Inbound Webhook
const initInboundWebhookState: types.IInboundWebhookState = {
    pending: false,
    inboundWebhook: null,
    error: null,
  };
  
  export const InboundWebhookReducer = (state = initInboundWebhookState, action: types.PostInboundWebhookActions) => {
    switch (action.type) {
      case actionTypes.POST_INBOUND_WEBHOOK_REQUEST:
        return {
          ...state,
          pending: true,
        };
      case actionTypes.POST_INBOUND_WEBHOOK_SUCCESS:
        return {
          ...state,
          pending: false,
          inboundWebhook: action.payload.inboundWebhook,
          error: null,
        };
      case actionTypes.POST_INBOUND_WEBHOOK_FAILURE:
        return {
          ...state,
          pending: false,
          inboundWebhook: null,
          error: action.payload.error,
        };
      default:
        return {
          ...state,
        };
    }
  };

  // Outbound Webhook
const initOutboundWebhookState: types.IOutboundWebhookState = {
  pending: false,
  outboundWebhook: null,
  error: null,
};

export const OutboundWebhookReducer = (state = initOutboundWebhookState, action: types.PostOutboundWebhookActions) => {
  switch (action.type) {
    case actionTypes.POST_OUTBOUND_WEBHOOK_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case actionTypes.POST_OUTBOUND_WEBHOOK_SUCCESS:
      return {
        ...state,
        pending: false,
        outboundWebhook: action.payload.outboundWebhook,
        error: null,
      };
    case actionTypes.POST_OUTBOUND_WEBHOOK_FAILURE:
      return {
        ...state,
        pending: false,
        outboundWebhook: null,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};


const initOutboundWebhookListState: types.OutboundWebhookListState = {
  pending: false,
  outboundWebhookList: {} as types.IDataOutboundWebhookList,
  error: null,
};

export const OutboundWebhookListReducer = (state = initOutboundWebhookListState, action: types.OutboundWebhookListActions) => {
  switch (action.type) {
      case actionTypes.FETCH_OUTBOUND_WEBHOOK_LIST_REQUEST:
          return {
              ...state,
              pending: true,
          };
      case actionTypes.FETCH_OUTBOUND_WEBHOOK_LIST_SUCCESS:
          return {
              ...state,
              pending: false,
              outboundWebhookList: action.payload.outboundWebhookList,
              error: null,
          };
      case actionTypes.FETCH_OUTBOUND_WEBHOOK_LIST_FAILURE:
          return {
              ...state,
              pending: false,
              outboundWebhookList: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }
};

//Put Inbound extractor
const initialPutStateInbound: types.IPutInboundState = {
  pending: false,
  status: null,
  error: null,
};

export const PutInboundReducer = (state = initialPutStateInbound, action: types.PutInboundActions) => {
  switch (action.type) {
      case actionTypes.PUT_INBOUND_WEBHOOK_REQUEST:
          return {
              ...state,
              pending: true,
          };
      case actionTypes.PUT_INBOUND_WEBHOOK_SUCCESS:
          return {
              ...state,
              pending: false,
              status: action.payload.status,
              error: null,
          };
      case actionTypes.PUT_INBOUND_WEBHOOK_FAILURE:
          return {
              ...state,
              pending: false,
              status: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }
};

//Put Outbound extractor
const initialPutStateOutbound: types.IPutOutboundState = {
  pending: false,
  status: null,
  error: null,
};

export const PutOutboundReducer = (state = initialPutStateOutbound, action: types.PutOutboundActions) => {
  switch (action.type) {
      case actionTypes.PUT_OUTBOUND_WEBHOOK_REQUEST:
          return {
              ...state,
              pending: true,
          };
      case actionTypes.PUT_OUTBOUND_WEBHOOK_SUCCESS:
          return {
              ...state,
              pending: false,
              status: action.payload.status,
              error: null,
          };
      case actionTypes.PUT_OUTBOUND_WEBHOOK_FAILURE:
          return {
              ...state,
              pending: false,
              status: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }
};

// DELETE Outbound Details

const initDeleteOutboundState: types.IDeleteOutboundState = {
  pending: false,
  success: null,
  error: null,
};

export const DeleteOutboundReducer = (state = initDeleteOutboundState, action: types.DeleteOutboundActions) => {
  switch (action.type) {
      case actionTypes.DELETE_OUTBOUND_WEBHOOK_REQUEST:
          return {
              ...state,
              success: null,
              pending: true,
          };
      case actionTypes.DELETE_OUTBOUND_WEBHOOK_SUCCESS:
          return {
              ...state,
              pending: false,
              success: action.success,
              error: null,
          };
      case actionTypes.DELETE_OUTBOUND_WEBHOOK_FAILURE:
          return {
              ...state,
              pending: false,
              success: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }
};